import { Typography } from "@mui/material";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import "../../css/dashboard.css";
import moment from "moment";

export default function TimeStream({ onTimeUpdate, value }) {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000); // 1초마다 갱신

    // 컴포넌트가 언마운트 될 때 clearInterval을 호출하여 메모리 누수를 방지
    return () => clearInterval(intervalId);
  }, []); // 빈 배열을 전달하여 컴포넌트가 마운트 될 때만 실행

  // 현재 날짜와 시간을 "YYYY-MM-DD HH:mm:ss" 형식으로 포맷
  const formattedTime = currentTime.toLocaleString("ko-KR", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false, // 24시간 형식 사용
  });

  useEffect(() => {
    onTimeUpdate(
      moment(new Date(currentTime)).subtract(1, "days").format("YYYYMMDD")
    );
  }, [value]);

  return (
    <Typography
      sx={{
        textAlign: "center",
        color: "#000000",
        fontSize: "1.2rem",
        paddingLeft: 60,
        paddingRight: 2,
        paddingTop: 1,
        fontFamily: "Archivo",
      }}
      variant="h6"
    >
      {formattedTime}
    </Typography>
  );
}
